export type ClientPlatformHeader = 'PC' | 'MOBILE'
export type DeviceTypeHeader = 'IOS' | 'AOS'

type NavigatorWithUserAgentData = Navigator & {
  userAgentData?: {
    platform?: string
  }
}

export const getClientPlatformHeader = (): ClientPlatformHeader =>
  import.meta.env.VITE_PLATFORM === 'MOBILE' ? 'MOBILE' : 'PC'

export const getDeviceTypeHeader = (
  navigatorRef: NavigatorWithUserAgentData | undefined = globalThis.navigator as
    | NavigatorWithUserAgentData
    | undefined,
): DeviceTypeHeader | undefined => {
  if (!navigatorRef) return undefined

  const platform = navigatorRef.userAgentData?.platform ?? navigatorRef.platform ?? ''
  const userAgent = navigatorRef.userAgent ?? ''
  const source = `${platform} ${userAgent}`

  if (/android/i.test(source)) return 'AOS'
  if (/iphone|ipad|ipod/i.test(source)) return 'IOS'

  // iPadOS 13+ can report itself as Mac in desktop-mode Safari/WebView.
  if (/mac/i.test(platform) && navigatorRef.maxTouchPoints > 1) return 'IOS'

  return undefined
}
